import {ConditionLine} from "../ConditionLine";
import * as React from "react";
import {ReactNode} from "react";


import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import './ComparatorBase.css';
import {Sanitizer} from "shared/utilities/Sanitizer";
import {ConditionLineTypeEnum} from "./ComparatorFactory";
import {ConditionLineOptions} from "../ConditionBuilder";
import {ToastService} from "shared/core/services/ToastService";

declare var RNGlobalVar:any;

export abstract class ComparatorBase {
    public Condition:ConditionLine;

    public Initialize(Condition:ConditionLine)
    {
        this.Condition=Condition;
        if(this.Condition.props.ConditionLineOptions.Comparison==ComparisonTypeEnum.None)
            this.InitializeValues();
        return this;
    }

    public get ConditionField(){
        if(this.Fields.length==0)
            return null;
        return this.Fields.find(x=>x.Id==this.Condition.props.ConditionLineOptions.FieldId);
    }



    public abstract GetComparator(skipValueLessConditions:boolean):ReactNode;

    public abstract GetValueInput():ReactNode;

    public abstract InitializeValues();

    public get Fields()
    {
        return this.Condition.ConditionGroup.ConditionBuilder.props.Fields;
    }


    public Render(){
        let fields:FieldDTO[]=this.Fields.filter(x=>x.UseInConditions);

        if(fields==null)
            return (
                <p>Please select a form first</p>
            )

        let value=this.Condition.props.ConditionLineOptions.FieldId;
        if(this.Condition.props.ConditionLineOptions.Type==ConditionLineTypeEnum.Custom)
            value='rncustom_'+value;
        if(this.Condition.props.ConditionLineOptions.PathId=='')
            value='';

        let valueInput=this.GetValueInput();

        return (
            <div>
                <div className={'conditionLine'} style={{display:'flex',alignItems:'flex-start',marginBottom:'5px',padding:5}}>
                    <div style={{width:'30%'}} className={'conditionColumn'}>
                        <select value={value} style={{height:'auto',padding:0,width:'100%',paddingRight:25}} className={value==''&&this.ShouldShowErrors()?'rnInvalidCondition':''} onChange={x=>this.FieldChanged(x.target.value, x.target[x.target.selectedIndex].getAttribute('data-linetype').toString(),x.target[x.target.selectedIndex] as any)}>
                            <option data-linetype={ConditionLineTypeEnum.None.toString()} id={''}>Select a field</option>
                            <optgroup label='Fields'>
                                {fields.map(field=>
                                    <option data-path-id={field.Id} data-field-id={field.Id} data-linetype={ConditionLineTypeEnum.Standard.toString()} key={field.Id+'_'+field.Id} value={field.Id}>{(0>0?'\u00A0\u00A0\u00A0\u00A0':'')+field.Label}</option>
                                )}
                            </optgroup>
                        </select>
                    </div>
                    <div style={{width:valueInput!=null?'20%':'calc(70% - 80px)'}} className={'conditionColumn'}>
                        {this.GetComparator(false)}
                    </div>


                    {valueInput!=null&&
                    <div style={{width: 'calc(50% - 80px)'}} className={'conditionColumn'}>
                        {valueInput}
                    </div>
                    }
                    <div style={{width:'80px'}} className={'conditionColumn'}>
                        <button onClick={x=>{x.preventDefault();this.Condition.props.OnAddLine(this.Condition.props.ConditionLineOptions)}} className={'rnbtn rnbtn-light'} style={{padding:'1px 5px'}}>AND</button>
                        <span className={'ConditionRemove'} style={{lineHeight:'25px',verticalAlign:'middle',cursor:'pointer'}} onClick={x=>{x.preventDefault();this.Condition.props.OnRemoveLine(this.Condition.props.ConditionLineOptions)}} ><FontAwesomeIcon icon={faTimes} style={{marginLeft:5}}/></span>
                    </div>


                </div>

            </div>
        )

    }

    public ShouldShowErrors(){
        return this.Condition.state.ShowValidations;
    }

    private FieldChanged(value: string, dataType: string, targetElement: HTMLOptionElement) {
        let subtype:string;
        let options:ConditionLineOptions;
        this.Condition.props.ConditionLineOptions.PathId='';

        if(ConditionLineTypeEnum[dataType]==ConditionLineTypeEnum.Standard)
        {
            let fieldId=targetElement.getAttribute('data-field-id');
            let field=this.Fields.find(x=>x.Id==fieldId);
            if(field==null)
                subtype="None";
            else
                subtype=field.Type;

            this.Condition.props.ConditionLineOptions.FieldId=fieldId;
            this.Condition.props.ConditionLineOptions.PathId=targetElement.getAttribute('data-path-id');
            if(field.Type=="Multiple")
                this.Condition.props.ConditionLineOptions.Value=Sanitizer.SanitizeStringArray(this.Condition.props.ConditionLineOptions.Value);
            else
                this.Condition.props.ConditionLineOptions.Value=Sanitizer.SanitizeString(this.Condition.props.ConditionLineOptions.Value);
        }else if(dataType==ConditionLineTypeEnum.Custom)
        {
            let fieldId=targetElement.getAttribute('data-field-id');

            subtype=ConditionLineTypeEnum.Custom;

            this.Condition.props.ConditionLineOptions.FieldId=fieldId;
            this.Condition.props.ConditionLineOptions.PathId=targetElement.getAttribute('data-path-id');
            this.Condition.props.ConditionLineOptions.Value=Sanitizer.SanitizeString(this.Condition.props.ConditionLineOptions.Value);
        }

        if(ConditionLineTypeEnum[dataType]==ConditionLineTypeEnum.None)
        {
            this.Condition.props.ConditionLineOptions.FieldId='';
        }

        this.Condition.props.ConditionLineOptions.Comparison=ComparisonTypeEnum.None;
        this.Condition.props.ConditionLineOptions.Type=ConditionLineTypeEnum[dataType];
        this.Condition.props.ConditionLineOptions.SubType=subtype;
        this.Condition.props.OnFieldChanged();
        this.Condition.forceUpdate();

    }

    SanitizeValue() {
        this.Condition.props.ConditionLineOptions.Value=Sanitizer.SanitizeString(this.Condition.props.ConditionLineOptions.Value);
    }


    ValueIsValid(){
        return this.Condition.props.ConditionLineOptions.Comparison==ComparisonTypeEnum.IsEmpty||
            this.Condition.props.ConditionLineOptions.Comparison==ComparisonTypeEnum.IsNotEmpty||
            Sanitizer.SanitizeString(this.Condition.props.ConditionLineOptions.Value)!='';
    }

    ComparisonIsValid(){
        return this.Condition.ConditionLineOptions.Comparison!=ComparisonTypeEnum.None
    }

    GetValueClass(){
        if(!this.ValueIsValid()&&this.Condition.state.ShowValidations)
            return 'rnInvalidCondition';
        return '';
    }

    GetComparisonClass(){
        if(!this.ComparisonIsValid()&&this.Condition.state.ShowValidations)
            return 'rnInvalidCondition';
        return '';
    }

    Validate():boolean {
        if(this.Condition.props.ConditionLineOptions.FieldId=='')
        {
            ToastService.SendErrorMessage('Please select a field');
            this.Condition.setState({ShowValidations:true});
            return false;
        }

        if(!this.ComparisonIsValid())
        {
            ToastService.SendErrorMessage('Invalid Comparison');
            this.Condition.setState({ShowValidations:true});
            return false;
        }

        if(!this.ValueIsValid())
        {
            ToastService.SendErrorMessage('Invalid Value');
            this.Condition.setState({ShowValidations:true});
            return false;
        }

        this.Condition.setState({ShowValidations:false});
        return true;
    }

}


export enum ComparisonTypeEnum {
    Equal='Equal',
    NotEqual='NotEqual',
    IsEmpty='IsEmpty',
    IsNotEmpty='IsNotEmpty',
    None='None',
    UserViewingThePage='UserViewingThePage',
    LastXEntries='LastXEntries',
    LastXEntriesByUser='LastXEntriesByUser',
    Contains='Contains',
    UserIs='UserIs',
    UserIsNot='UserIsNot',
    HasRole='HasRole',
    HasNotRole='HasNotRole',
    NotContains='NotContains',
    GreaterThan='GreaterThan',
    GreaterOrEqualThan='GreaterOrEqualThan',
    LessThan='LessThan',
    LessOrEqualThan='LessOrEqualThan',
    IsChecked='IsChecked',
    IsNotChecked='IsNotChecked'

}

